import { CashManagement } from "./cash-management.model";
import { SalesGroup } from "./sales-group.model";
import { Tax } from "./tax.model";
import { Tip } from "./tip.model";
import { MerchantDefaults } from "./merchant-defaults.model";

export class Settings {
  menus = new Array();
  printers = new Array();
  payTypes = new Array();
  orderTypes = new Array();
  parentGroups = new Array();
  salesGroups = new Array();
  kvds = new Array();
  taxes = new Array<Tax>();
  tip = new Tip();
  cashManagement = new CashManagement();
  defaults = new MerchantDefaults();
  salesGroupList = new Array<SalesGroup>();
  menuCategories = new Array();

  public load(data: any): Settings {

    Object.assign(this, data);

    this.taxes = new Array<Tax>();

    if (data.taxes) {
      data.taxes
          ?.forEach((t: Tax) => {
            this.taxes
                .push(new Tax().load(t));
          });
    }

    if (data.tips) {
      this.tip = new Tip().load(data.tips);
    }

    if (data.cashManagement) {
      this.cashManagement = new CashManagement().load(data.cashManagement)!;
    }

    if (data?.defaults){
      this.defaults = new MerchantDefaults().load(data.defaults);
    } else {
      this.defaults = new MerchantDefaults().load({});
    }

    //backwards compat
    if (data?.salesGroups) {
      this.salesGroups.forEach(s => {
        this.salesGroupList.push(new SalesGroup(s));
      });
    }

    return this;
  }
}
